import script from "./PhoneField.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneField.vue?vue&type=script&setup=true&lang=ts"

import "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&lang=css&external"
import "./PhoneField.vue?vue&type=style&index=1&id=5e91cb0e&lang=scss"

const __exports__ = script;

export default __exports__